import { IRole, IRolesTenantsMappings } from './authorization';
import { ICommon, UserStatus } from './common';

export interface IRolesTenants {
	[tenantId: string]: IRole[];
}

export interface IUserData extends IRolesTenantsMappings {
	externalIDs?: IExternalID[];
	displayName?: string;
	project?: string;
	logoutTime?: number;
	createdTime?: number;
	email?: string;
	phoneNumber?: string;
	status?: UserStatus;
	verifiedEmail?: boolean;
	verifiedPhone?: boolean;
	tenants?: string[];
	authorization?: {
		roles?: IRole[];
		rolesMT?: IRolesTenants;
	};
}

export interface IUser extends IUserData, ICommon {}

export type InviteFunc = (data: IInviteUsers) => Promise<IInviteUsers>;
export interface IUsers {
	users?: Array<IUser>;
	total: number;
}

export interface IConsoleUser extends IUserData {
	descopeUserId?: string;
	displayName?: string;
	externalIDs?: IExternalID[];
	companies?: string[];
	projects?: IProject[];
}

export interface IProject {
	id: string;
	name: string;
	companyId: string;
	companyName: string;
	maxAllowedProjects: number;
}

export interface IInviteUsers extends IRolesTenantsMappings {
	users: string[];
}

export interface IExternalID {
	id: string;
	type?: string;
}

export interface IBatchAction {
	ids: string[];
}

export enum TenantsRolesEditOperation {
	ADD = 'add',
	REMOVE = 'remove'
}

export interface ITenantsRolesEdit extends IRolesTenantsMappings {
	operation?: TenantsRolesEditOperation;
}

export interface IUpdateUserTenants extends ITenantsRolesEdit, IBatchAction {}
